import BaseStore from "@/v1/utils/BaseStore";

import { GET_SETUPS_INTEGRATORID_START, GET_SETUPS_INTEGRATORID_SUCCESS, 
  GET_WHITELISTED_IPS_INTEGRATORID_START, 
  GET_WHITELISTED_IPS_INTEGRATORID_SUCCESS } from "./types";

const initialState = {
  whitelistedIps: {
    results: [],
    loading: true,
  },
  setups: {
    results: [],
    page: {
      size: 10,
      totalElements: 0,
      totalPages: 0,
      number: 0,
    },
    loading: false,
  },
};

const store = new BaseStore("integrators", initialState);

const reducer = {
  [GET_SETUPS_INTEGRATORID_START]: state => ({
    ...state,
    setups: {
      ...state.setups,
      results: [],
      loading: true,
    }
  }),
  [GET_SETUPS_INTEGRATORID_SUCCESS]: (state, payload) => ({
    ...state,
    setups: {
      results: payload.results,
      page: payload.page,
      loading: false,
    },
  }),
  [GET_WHITELISTED_IPS_INTEGRATORID_START]: (state) => ({
    ...state,
    whitelistedIps: {
      ...state.whitelistedIps,
      results: [],
      loading: true,
    }
  }),
  [GET_WHITELISTED_IPS_INTEGRATORID_SUCCESS]: (state, payload) => ({
    ...state,
    whitelistedIps: {
      ...state.whitelistedIps,
      results: payload,
      loading: false,
    }
  }),
};

export default store.reducer(reducer);
